import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
const links = [{
  label: 'Términos de Servicio',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-coal-900 py-14 text-white md:py-16" data-id="element-46" data-mp="32m1et8sa9itd">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-47" data-mp="36n3c3k2n3ksp">
        <p className="inline-flex items-center gap-2.5 font-sans text-sm font-bold uppercase tracking-[0.14em] text-white md:text-base" data-id="element-48" data-mp="3uftlpmn2lrzt">
          <span className="h-2.5 w-2.5 rounded-full bg-forest-400 ring-4 ring-forest-400/15" aria-hidden="true" data-id="element-49" data-mp="3lem0o69kenno" />
          Biblioteca de Sabiduría de Salomón
        </p>

        <p className="mt-6 text-sm text-white/60" data-id="element-50" data-mp="29zgnu9fpz8qc">
          © 2026 Biblioteca de Sabiduría de Salomón | Todos los derechos reservados
        </p>

        <p className="mt-6 inline-flex items-center gap-2 rounded-xl bg-coal-800 px-4 py-2.5 text-sm font-semibold text-white/80 ring-1 ring-white/10" data-id="element-51" data-mp="2ezurzge79yj3">
          <HeartHandshakeIcon className="h-4 w-4 shrink-0 text-forest-400" aria-hidden="true" data-id="element-52" data-mp="3gaz376r4yrlo" />
          Si necesitás ayuda profesional, buscala: este material no sustituye la terapia
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm text-forest-300" data-id="element-53" data-mp="3q83svgk6x578">
          {links.map(link => <li key={link.label} data-id="element-54" data-mp="817b9zwxjeqw">
              <a href={link.href} className="transition-colors duration-150 ease-calm hover:text-white" data-id="element-55" data-mp="33xchtnnhqqe">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-white/10 pt-6 text-xs leading-relaxed text-white/55" data-id="element-56" data-mp="cus1h5sa74fj">
          Este producto es una herramienta de reflexión con fines educativos. Sus recursos no
          sustituyen la consulta médica, psicológica ni la intervención de un profesional de la
          salud.
        </p>
      </div>
    </footer>;
}